const ThemeDef = {
	sys: {
		control: { border: 'var(--schmancy-sys-control-border)' },
		color: {
			scrim: 'var(--schmancy-sys-color-scrim)',
			outline: 'var(--schmancy-sys-color-outline)',
			outlineVariant: 'var(--schmancy-sys-color-outlineVariant)',
			shadow: 'var(--schmancy-sys-color-shadow)',

			surface: {
				default: 'var(--schmancy-sys-color-surface-default)',
				dim: 'var(--schmancy-sys-color-surface-dim)',
				bright: 'var(--schmancy-sys-color-surface-bright)',
				container: 'var(--schmancy-sys-color-surface-container)',
				containerLow: 'var(--schmancy-sys-color-surface-containerLow)',
				containerLowest: 'var(--schmancy-sys-color-surface-containerLowest)',
				containerHigh: 'var(--schmancy-sys-color-surface-containerHigh)',
				containerHighest: 'var(--schmancy-sys-color-surface-containerHighest)',
				on: 'var(--schmancy-sys-color-surface-on)',
				onVariant: 'var(--schmancy-sys-color-surface-onVariant)',
				tint: 'var(--schmancy-sys-color-surface-tint)',
				inverse: 'var(--schmancy-sys-color-surface-inverse)',
				inverseOn: 'var(--schmancy-sys-color-surface-inverseOn)',
				// Deprecated mappings for backward compatibility
				low: 'var(--schmancy-sys-color-surface-containerLow)',
				high: 'var(--schmancy-sys-color-surface-containerHigh)',
				highest: 'var(--schmancy-sys-color-surface-containerHighest)',
				lowest: 'var(--schmancy-sys-color-surface-containerLowest)',
			},

			primary: {
				default: 'var(--schmancy-sys-color-primary-default)',
				on: 'var(--schmancy-sys-color-primary-on)',
				container: 'var(--schmancy-sys-color-primary-container)',
				onContainer: 'var(--schmancy-sys-color-primary-onContainer)',
				fixed: 'var(--schmancy-sys-color-primary-fixed)',
				fixedDim: 'var(--schmancy-sys-color-primary-fixedDim)',
				onFixed: 'var(--schmancy-sys-color-primary-onFixed)',
				onFixedVariant: 'var(--schmancy-sys-color-primary-onFixedVariant)',
				inverse: 'var(--schmancy-sys-color-primary-inverse)',
			},

			secondary: {
				default: 'var(--schmancy-sys-color-secondary-default)',
				on: 'var(--schmancy-sys-color-secondary-on)',
				container: 'var(--schmancy-sys-color-secondary-container)',
				onContainer: 'var(--schmancy-sys-color-secondary-onContainer)',
				fixed: 'var(--schmancy-sys-color-secondary-fixed)',
				fixedDim: 'var(--schmancy-sys-color-secondary-fixedDim)',
				onFixed: 'var(--schmancy-sys-color-secondary-onFixed)',
				onFixedVariant: 'var(--schmancy-sys-color-secondary-onFixedVariant)',
			},

			tertiary: {
				default: 'var(--schmancy-sys-color-tertiary-default)',
				on: 'var(--schmancy-sys-color-tertiary-on)',
				container: 'var(--schmancy-sys-color-tertiary-container)',
				onContainer: 'var(--schmancy-sys-color-tertiary-onContainer)',
				fixed: 'var(--schmancy-sys-color-tertiary-fixed)',
				fixedDim: 'var(--schmancy-sys-color-tertiary-fixedDim)',
				onFixed: 'var(--schmancy-sys-color-tertiary-onFixed)',
				onFixedVariant: 'var(--schmancy-sys-color-tertiary-onFixedVariant)',
			},

			// `pinned`/`onPinned` are the scheme-stable filled pair — see theme.format.ts.
			error: {
				default: 'var(--schmancy-sys-color-error-default)',
				on: 'var(--schmancy-sys-color-error-on)',
				container: 'var(--schmancy-sys-color-error-container)',
				onContainer: 'var(--schmancy-sys-color-error-onContainer)',
				pinned: 'var(--schmancy-sys-color-error-pinned)',
				onPinned: 'var(--schmancy-sys-color-error-onPinned)',
			},

			success: {
				default: 'var(--schmancy-sys-color-success-default)',
				on: 'var(--schmancy-sys-color-success-on)',
				container: 'var(--schmancy-sys-color-success-container)',
				onContainer: 'var(--schmancy-sys-color-success-onContainer)',
				pinned: 'var(--schmancy-sys-color-success-pinned)',
				onPinned: 'var(--schmancy-sys-color-success-onPinned)',
			},

			warning: {
				default: 'var(--schmancy-sys-color-warning-default)',
				on: 'var(--schmancy-sys-color-warning-on)',
				container: 'var(--schmancy-sys-color-warning-container)',
				onContainer: 'var(--schmancy-sys-color-warning-onContainer)',
				pinned: 'var(--schmancy-sys-color-warning-pinned)',
				onPinned: 'var(--schmancy-sys-color-warning-onPinned)',
			},

			info: {
				default: 'var(--schmancy-sys-color-info-default)',
				on: 'var(--schmancy-sys-color-info-on)',
				container: 'var(--schmancy-sys-color-info-container)',
				onContainer: 'var(--schmancy-sys-color-info-onContainer)',
				pinned: 'var(--schmancy-sys-color-info-pinned)',
				onPinned: 'var(--schmancy-sys-color-info-onPinned)',
			},

			// Peer tints for a deterministic per-entity rotation — see theme.format.ts.
			// Equal weight by construction; index carries no meaning beyond "a different
			// one", so nothing here may be read as a state the way error/success are.
			identity: {
				0: {
					container: 'var(--schmancy-sys-color-identity-0-container)',
					onContainer: 'var(--schmancy-sys-color-identity-0-onContainer)',
				},
				1: {
					container: 'var(--schmancy-sys-color-identity-1-container)',
					onContainer: 'var(--schmancy-sys-color-identity-1-onContainer)',
				},
				2: {
					container: 'var(--schmancy-sys-color-identity-2-container)',
					onContainer: 'var(--schmancy-sys-color-identity-2-onContainer)',
				},
				3: {
					container: 'var(--schmancy-sys-color-identity-3-container)',
					onContainer: 'var(--schmancy-sys-color-identity-3-onContainer)',
				},
				4: {
					container: 'var(--schmancy-sys-color-identity-4-container)',
					onContainer: 'var(--schmancy-sys-color-identity-4-onContainer)',
				},
				5: {
					container: 'var(--schmancy-sys-color-identity-5-container)',
					onContainer: 'var(--schmancy-sys-color-identity-5-onContainer)',
				},
			},

			// The categorical chart scale — see theme.format.ts. Fixed order, one
			// step per data series; `on` is the ink a label placed on that step wears.
			series: {
				0: { default: 'var(--schmancy-sys-color-series-0-default)', on: 'var(--schmancy-sys-color-series-0-on)' },
				1: { default: 'var(--schmancy-sys-color-series-1-default)', on: 'var(--schmancy-sys-color-series-1-on)' },
				2: { default: 'var(--schmancy-sys-color-series-2-default)', on: 'var(--schmancy-sys-color-series-2-on)' },
				3: { default: 'var(--schmancy-sys-color-series-3-default)', on: 'var(--schmancy-sys-color-series-3-on)' },
				4: { default: 'var(--schmancy-sys-color-series-4-default)', on: 'var(--schmancy-sys-color-series-4-on)' },
				5: { default: 'var(--schmancy-sys-color-series-5-default)', on: 'var(--schmancy-sys-color-series-5-on)' },
			},
		},

		typography: {
			display: {
				large: 'var(--schmancy-sys-typescale-display-large)',
				medium: 'var(--schmancy-sys-typescale-display-medium)',
				small: 'var(--schmancy-sys-typescale-display-small)',
			},
			headline: {
				large: 'var(--schmancy-sys-typescale-headline-large)',
				medium: 'var(--schmancy-sys-typescale-headline-medium)',
				small: 'var(--schmancy-sys-typescale-headline-small)',
			},
			title: {
				large: 'var(--schmancy-sys-typescale-title-large)',
				medium: 'var(--schmancy-sys-typescale-title-medium)',
				small: 'var(--schmancy-sys-typescale-title-small)',
			},
			body: {
				large: 'var(--schmancy-sys-typescale-body-large)',
				medium: 'var(--schmancy-sys-typescale-body-medium)',
				small: 'var(--schmancy-sys-typescale-body-small)',
			},
			label: {
				large: 'var(--schmancy-sys-typescale-label-large)',
				medium: 'var(--schmancy-sys-typescale-label-medium)',
				small: 'var(--schmancy-sys-typescale-label-small)',
			},
		},

		elevation: {
			0: 'var(--schmancy-sys-elevation-0)',
			1: 'var(--schmancy-sys-elevation-1)',
			2: 'var(--schmancy-sys-elevation-2)',
			3: 'var(--schmancy-sys-elevation-3)',
			4: 'var(--schmancy-sys-elevation-4)',
			5: 'var(--schmancy-sys-elevation-5)',
		},

		// Liquid-glass material — shared translucent treatment for every glass surface
		glass: {
			fill: 'var(--schmancy-sys-glass-fill)',
			blur: 'var(--schmancy-sys-glass-blur)',
			saturate: 'var(--schmancy-sys-glass-saturate)',
			border: 'var(--schmancy-sys-glass-border)',
		},

		motion: {
			easing: {
				emphasized: 'var(--schmancy-sys-motion-easing-emphasized)',
				emphasizedDecelerate: 'var(--schmancy-sys-motion-easing-emphasizedDecelerate)',
				emphasizedAccelerate: 'var(--schmancy-sys-motion-easing-emphasizedAccelerate)',
				standard: 'var(--schmancy-sys-motion-easing-standard)',
				standardDecelerate: 'var(--schmancy-sys-motion-easing-standardDecelerate)',
				standardAccelerate: 'var(--schmancy-sys-motion-easing-standardAccelerate)',
				legacy: 'var(--schmancy-sys-motion-easing-legacy)',
				linear: 'var(--schmancy-sys-motion-easing-linear)',
			},
			duration: {
				short1: 'var(--schmancy-sys-motion-duration-short1)',
				short2: 'var(--schmancy-sys-motion-duration-short2)',
				short3: 'var(--schmancy-sys-motion-duration-short3)',
				short4: 'var(--schmancy-sys-motion-duration-short4)',
				medium1: 'var(--schmancy-sys-motion-duration-medium1)',
				medium2: 'var(--schmancy-sys-motion-duration-medium2)',
				medium3: 'var(--schmancy-sys-motion-duration-medium3)',
				medium4: 'var(--schmancy-sys-motion-duration-medium4)',
				long1: 'var(--schmancy-sys-motion-duration-long1)',
				long2: 'var(--schmancy-sys-motion-duration-long2)',
				long3: 'var(--schmancy-sys-motion-duration-long3)',
				long4: 'var(--schmancy-sys-motion-duration-long4)',
				extraLong1: 'var(--schmancy-sys-motion-duration-extraLong1)',
				extraLong2: 'var(--schmancy-sys-motion-duration-extraLong2)',
				extraLong3: 'var(--schmancy-sys-motion-duration-extraLong3)',
				extraLong4: 'var(--schmancy-sys-motion-duration-extraLong4)',
			},
		},

		state: {
			opacity: {
				hover: 'var(--schmancy-sys-state-opacity-hover)',
				focus: 'var(--schmancy-sys-state-opacity-focus)',
				pressed: 'var(--schmancy-sys-state-opacity-pressed)',
				dragged: 'var(--schmancy-sys-state-opacity-dragged)',
				disabled: 'var(--schmancy-sys-state-opacity-disabled)',
				disabledContainer: 'var(--schmancy-sys-state-opacity-disabledContainer)',
			},
		},

		spacing: {
			0: 'var(--schmancy-sys-spacing-0)',
			1: 'var(--schmancy-sys-spacing-1)',
			2: 'var(--schmancy-sys-spacing-2)',
			3: 'var(--schmancy-sys-spacing-3)',
			4: 'var(--schmancy-sys-spacing-4)',
			5: 'var(--schmancy-sys-spacing-5)',
			6: 'var(--schmancy-sys-spacing-6)',
			7: 'var(--schmancy-sys-spacing-7)',
			8: 'var(--schmancy-sys-spacing-8)',
			9: 'var(--schmancy-sys-spacing-9)',
			10: 'var(--schmancy-sys-spacing-10)',
			11: 'var(--schmancy-sys-spacing-11)',
			12: 'var(--schmancy-sys-spacing-12)',
		},

		// Legacy top-level outline width, kept for consumers predating sys.color.outline.
		outline: {
			1: 'var(--schmancy-sys-outline-1)',
		},
	},

	ref: {
		palette: {
			primary: {
				0: 'var(--schmancy-ref-palette-primary-0)',
				10: 'var(--schmancy-ref-palette-primary-10)',
				20: 'var(--schmancy-ref-palette-primary-20)',
				30: 'var(--schmancy-ref-palette-primary-30)',
				40: 'var(--schmancy-ref-palette-primary-40)',
				50: 'var(--schmancy-ref-palette-primary-50)',
				60: 'var(--schmancy-ref-palette-primary-60)',
				70: 'var(--schmancy-ref-palette-primary-70)',
				80: 'var(--schmancy-ref-palette-primary-80)',
				90: 'var(--schmancy-ref-palette-primary-90)',
				95: 'var(--schmancy-ref-palette-primary-95)',
				99: 'var(--schmancy-ref-palette-primary-99)',
				100: 'var(--schmancy-ref-palette-primary-100)',
			},
			secondary: {
				0: 'var(--schmancy-ref-palette-secondary-0)',
				10: 'var(--schmancy-ref-palette-secondary-10)',
				20: 'var(--schmancy-ref-palette-secondary-20)',
				30: 'var(--schmancy-ref-palette-secondary-30)',
				40: 'var(--schmancy-ref-palette-secondary-40)',
				50: 'var(--schmancy-ref-palette-secondary-50)',
				60: 'var(--schmancy-ref-palette-secondary-60)',
				70: 'var(--schmancy-ref-palette-secondary-70)',
				80: 'var(--schmancy-ref-palette-secondary-80)',
				90: 'var(--schmancy-ref-palette-secondary-90)',
				95: 'var(--schmancy-ref-palette-secondary-95)',
				99: 'var(--schmancy-ref-palette-secondary-99)',
				100: 'var(--schmancy-ref-palette-secondary-100)',
			},
			tertiary: {
				0: 'var(--schmancy-ref-palette-tertiary-0)',
				10: 'var(--schmancy-ref-palette-tertiary-10)',
				20: 'var(--schmancy-ref-palette-tertiary-20)',
				30: 'var(--schmancy-ref-palette-tertiary-30)',
				40: 'var(--schmancy-ref-palette-tertiary-40)',
				50: 'var(--schmancy-ref-palette-tertiary-50)',
				60: 'var(--schmancy-ref-palette-tertiary-60)',
				70: 'var(--schmancy-ref-palette-tertiary-70)',
				80: 'var(--schmancy-ref-palette-tertiary-80)',
				90: 'var(--schmancy-ref-palette-tertiary-90)',
				95: 'var(--schmancy-ref-palette-tertiary-95)',
				99: 'var(--schmancy-ref-palette-tertiary-99)',
				100: 'var(--schmancy-ref-palette-tertiary-100)',
			},
			neutral: {
				0: 'var(--schmancy-ref-palette-neutral-0)',
				10: 'var(--schmancy-ref-palette-neutral-10)',
				20: 'var(--schmancy-ref-palette-neutral-20)',
				30: 'var(--schmancy-ref-palette-neutral-30)',
				40: 'var(--schmancy-ref-palette-neutral-40)',
				50: 'var(--schmancy-ref-palette-neutral-50)',
				60: 'var(--schmancy-ref-palette-neutral-60)',
				70: 'var(--schmancy-ref-palette-neutral-70)',
				80: 'var(--schmancy-ref-palette-neutral-80)',
				90: 'var(--schmancy-ref-palette-neutral-90)',
				95: 'var(--schmancy-ref-palette-neutral-95)',
				99: 'var(--schmancy-ref-palette-neutral-99)',
				100: 'var(--schmancy-ref-palette-neutral-100)',
			},
			neutralVariant: {
				0: 'var(--schmancy-ref-palette-neutralVariant-0)',
				10: 'var(--schmancy-ref-palette-neutralVariant-10)',
				20: 'var(--schmancy-ref-palette-neutralVariant-20)',
				30: 'var(--schmancy-ref-palette-neutralVariant-30)',
				40: 'var(--schmancy-ref-palette-neutralVariant-40)',
				50: 'var(--schmancy-ref-palette-neutralVariant-50)',
				60: 'var(--schmancy-ref-palette-neutralVariant-60)',
				70: 'var(--schmancy-ref-palette-neutralVariant-70)',
				80: 'var(--schmancy-ref-palette-neutralVariant-80)',
				90: 'var(--schmancy-ref-palette-neutralVariant-90)',
				95: 'var(--schmancy-ref-palette-neutralVariant-95)',
				99: 'var(--schmancy-ref-palette-neutralVariant-99)',
				100: 'var(--schmancy-ref-palette-neutralVariant-100)',
			},
			error: {
				0: 'var(--schmancy-ref-palette-error-0)',
				10: 'var(--schmancy-ref-palette-error-10)',
				20: 'var(--schmancy-ref-palette-error-20)',
				30: 'var(--schmancy-ref-palette-error-30)',
				40: 'var(--schmancy-ref-palette-error-40)',
				50: 'var(--schmancy-ref-palette-error-50)',
				60: 'var(--schmancy-ref-palette-error-60)',
				70: 'var(--schmancy-ref-palette-error-70)',
				80: 'var(--schmancy-ref-palette-error-80)',
				90: 'var(--schmancy-ref-palette-error-90)',
				95: 'var(--schmancy-ref-palette-error-95)',
				99: 'var(--schmancy-ref-palette-error-99)',
				100: 'var(--schmancy-ref-palette-error-100)',
			},
		},
	},
}
const theme = {
	theme: ThemeDef,
}

export type TSchmancyTheme = (typeof theme)[keyof typeof theme] & {
	// BCP 47 language tag; defaults to navigator.language, overridable via the
	// schmancy-theme element's locale attribute.
	locale: string
}

// Every value here is a var(--schmancy-...) reference, not a resolved color —
// SchmancyTheme reads through to whatever the nearest <schmancy-theme> sets.
const SchmancyTheme: TSchmancyTheme = {
	...ThemeDef,
	locale: typeof navigator !== 'undefined' ? navigator.language : 'de-DE',
}

export { SchmancyTheme }
